<template>
    <div class="stock-config-card">
        <div class="stock-header-row">
            <input-search class="stock-action-search" @getData="getSearch" />
            <div class="stock-actions-row">
                <div class="position-relative d-inline-flex">
                    <select
                        v-model="selectedStockStatus"
                        class="btn btn-sm bg-white fw-400 select-like-btn"
                        @change="onStockStatusChange"
                        style="padding:0 44px;min-width:180px;text-align:center;color:black!important;border:1px solid black!important"
                    >
                        <option value="">Todos</option>
                        <option value="normal">Normal</option>
                        <option value="quiebre">Quiebre</option>
                        <option value="sobrestock">Sobrestock</option>
                        <option value="por_configurar">Por configurar</option>
                    </select>
                    <img src="/icons/filter-recomendation.svg" alt="filter" class="icons-dark" style="position:absolute;left:10px;top:50%;transform:translateY(-50%);pointer-events:none" />
                </div>
                <button 
                    class="btn btn-sm bg-white fw-400"
                    style="
                        color: black !important;  
                        border: 1px solid black !important
                    "
                    @click="viewConfig('','config-stock-options','Configuración de stock','Establece los umbrales de stock para varios productos de manera simultánea')"
                >
                    Configuración en lote
                </button>
                <button 
                    class="btn fw-500 button-export text-white rounder-8 button-products d-flex align-items-center"
                    @click="exportDataFile"
                >
                    <img src="/icons/down.svg" alt="icono" class="me-1 icons">Exportar
                </button>
            </div>
        </div>

        <div class="stock-table-info-row">
            <span 
                class="stock-total-count"
                v-if = "totalCount > 0 && !loading"
            >
                Total: {{ totalCount }}
            </span>
        </div>
        <div class="table-responsive border" v-if="products.length > 0 || loading">
            <placeholder v-if="loading" :type="'table'" :count="3"/>
            <table class="stock-table w-100" v-else>
                <thead>
                    <tr>
                        <th v-if="isColumnVisible('sku')">{{ getColumnLabel('sku') }}</th>
                        <th v-if="isColumnVisible('long_name')">{{ getColumnLabel('long_name') }}</th>
                        <th
                            v-if="isColumnVisible('store_name')"
                        >
                            {{ getColumnLabel('store_name') }}
                        </th>
                        <th v-if="isColumnVisible('coverage_days_min')" class="editable-header">{{ getColumnLabel('coverage_days_min') }}</th>
                        <th v-if="isColumnVisible('coverage_days')">{{ getColumnLabel('coverage_days') }}</th>
                        <th v-if="isColumnVisible('coverage_days_max')" class="editable-header">{{ getColumnLabel('coverage_days_max') }}</th>
                        <th v-if="isColumnVisible('price_action')" class="editable-header">{{ getColumnLabel('price_action') }}</th>
                        <th v-if="isColumnVisible('stock_situation')" class="editable-header">{{ getColumnLabel('stock_situation') }}</th>
                        <th v-if="isColumnVisible('inventory_alarm_type')">{{ getColumnLabel('inventory_alarm_type') }}</th>
                        <th v-if="isColumnVisible('actions')">{{ getColumnLabel('actions') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="(product, index) in products" :key="index"
                    >
                        <td v-if="isColumnVisible('sku')">
                            <span class="stock-sku-badge">{{ product.sku }}</span>
                        </td>
                        <td v-if="isColumnVisible('long_name')">{{ product.long_name }}</td>
                        <td
                            v-if="isColumnVisible('store_name')"
                        >
                            {{ product.store_name }}
                        </td>
                        <td v-if="isColumnVisible('coverage_days_min')" class="col-highlight">{{ product.coverage_days_min !== null && product.coverage_days !== undefined ? product.coverage_days_min : '—' }}</td>
                        <td v-if="isColumnVisible('coverage_days')">{{ product.coverage_days !== null && product.coverage_days !== undefined ? product.coverage_days : '—' }}</td>
                        <td v-if="isColumnVisible('coverage_days_max')" class="col-highlight">{{ product.coverage_days_max !== null && product.coverage_days !== undefined ? product.coverage_days_max : '—' }}</td>
                        <td v-if="isColumnVisible('price_action')" class="col-highlight">
                            <span
                                v-if="getPriceActionLabel(product.price_action)"
                                class="price-action-badge"
                            >
                                {{ getPriceActionLabel(product.price_action) }}
                            </span>
                            <span v-else>—</span>
                        </td>
                        <td v-if="isColumnVisible('stock_situation')" class="col-highlight">
                            <span
                                v-if="getStockSituationLabel(product.stock_situation)"
                                class="inventory-alarm-badge"
                                :class="getStockSituationBadgeClass(product.stock_situation)"
                            >
                                {{ getStockSituationLabel(product.stock_situation) }}
                            </span>
                            <span v-else class="inventory-alarm-badge inventory-alarm-badge--neutral">—</span>
                        </td>
                        <td v-if="isColumnVisible('inventory_alarm_type')">
                            <span
                                v-if="getInventoryAlarmTypeLabel(product.inventory_alarm_type)"
                                class="inventory-alarm-badge"
                                :class="getInventoryAlarmTypeBadgeClass(product.inventory_alarm_type)"
                            >
                                {{ getInventoryAlarmTypeLabel(product.inventory_alarm_type) }}
                            </span>
                            <span v-else>—</span>
                        </td>
                        <td v-if="isColumnVisible('actions')">
                            <div class="d-flex flex-column gap-1">
                                <span
                                    @click="viewConfig(product,'config-stock-one','Configuración de stock','Establece los umbrales de stock mínimo, objetivo y máximo para el producto seleccionado')"
                                >
                                    <img class="cursor-pointer" src="/icons/pencil-margin.svg" alt="Editar"/>
                                </span>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- No data message -->
        <div v-if="products.length <= 0 && !loading" class="p-4 bg-white rounder-8 border border-1 text-center">
            <h4 class="fw-400 size-18 text-secondary">No existe información para mostrar</h4>
        </div>

        <PaginationControls
            v-if="totalCount > 0"
            :current-page="currentPage"
            :total-count="totalCount"
            :page-size="pageSize"
            @change-page="$emit('change-page', $event)"
            @change-page-size="$emit('change-page-size', $event)"
        />
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import inputSearch from '@/components/inputSearch.vue';
import Placeholder from "../../../../../components/loadings/placeholder.vue";
import PaginationControls from "../../../../../components/PaginationControls.vue";
import configsRecTableMixin from '../mixins/configsRecTableMixin.js'

export default {
    name: 'table-stock-config',
    mixins: [configsRecTableMixin],
    components: {
        inputSearch,
        Placeholder,
        PaginationControls
    },
    props: {
        products: {
            type: Array,
            required: true,
            default: () => []
        },
        loading: {
            type: Boolean,
            default: false
        },
        totalCount: {
            type: Number,
            default: 0
        },
        currentPage: {
            type: Number,
            default: 1
        },
        pageSize: {
            type: Number,
            default: 25
        }
    },
    data() {
        return {
            search_product: '',
            search_type: 'codigo',
            selectedStockStatus: '',
            tableConfigKey: 'stock',
            priceActionOptions: [
                { value: 'Subir el precio para desacelerar venta', label: 'Subir px' },
                { value: 'Bloquear cambio de precio', label: 'Bloquear px' },
                { value: 'Bajar el precio para acelerar rotacion', label: 'Bajar px' },
                { value: 'Activar promocion automatica', label: 'Activar promocion' },
                { value: 'Solo alerta, sin accion', label: 'Solo alerta' },
            ],
        }
    },
    computed: {
        ...mapGetters([
            "authentication_user",
            "activeDesk"
        ]),
    },
    methods: {
        ...mapActions(["executeCommit", "get"]),
        getPriceActionLabel(value) {
            if (!value) {
                return '';
            }

            const normalizedValue = String(value).trim();
            const option = this.priceActionOptions.find(item => item.value === normalizedValue);
            return option ? option.label : normalizedValue;
        },
        getInventoryAlarmTypeLabel(value) {
            if (!value) {
                return 'Por configurar';
            }

            const normalizedValue = String(value).trim().toLowerCase();
            const labels = {
                normal: 'Normal',
                quiebre: 'Quiebre',
                sobrestock: 'Sobrestock',
                por_configurar: 'Por configurar',
            };

            return labels[normalizedValue] || String(value).trim();
        },
        getInventoryAlarmTypeBadgeClass(value) {
            const normalizedValue = String(value || '').trim().toLowerCase();

            if (normalizedValue === 'normal') {
                return 'inventory-alarm-badge--normal';
            }

            if (normalizedValue === 'quiebre') {
                return 'inventory-alarm-badge--quiebre';
            }

            if (normalizedValue === 'sobrestock') {
                return 'inventory-alarm-badge--stock';
            }

            if (normalizedValue === 'por_configurar') {
                return 'inventory-alarm-badge--neutral';
            }

            return 'inventory-alarm-badge--neutral';
        },
        getStockSituationLabel(value) {
            if (!value) {
                return '';
            }

            const normalizedValue = String(value).trim().toLowerCase();
            const labels = {
                quiebre: 'Quiebre',
                sobrestock: 'Sobrestock',
            };

            return labels[normalizedValue] || String(value).trim();
        },
        getStockSituationBadgeClass(value) {
            const normalizedValue = String(value || '').trim().toLowerCase();

            if (normalizedValue === 'quiebre') {
                return 'inventory-alarm-badge--quiebre';
            }

            if (normalizedValue === 'sobrestock') {
                return 'inventory-alarm-badge--stock';
            }

            return 'inventory-alarm-badge--neutral';
        },
        getSearch(row) {
            this.search_product = row.search
            this.search_type = row.searchType
            this.$emit('getData', 
                this.search_product,
                this.search_type
            )
        },
        onStockStatusChange() {
            this.$emit('filterStockStatus', this.selectedStockStatus);
        },
        viewConfig(row, name, title, text) {
            this.$emit('viewModal', row, name, title, text);
        },
        exportDataFile() {
            this.executeCommit({ mutation: "loading_state_component" });
            let url = `/api/products/export_config_stock/`;
            if (!this.authentication_user.client_channel) {
                url = url + `?business=${this.authentication_user.client_business_select}`
            }
            this.get({
                url: url,
            }).then(() => {
                this.executeCommit({ mutation: "loading_state_component" });
                this.$notification.success(
                    "En un momento te llegará un correo electrónico con los datos de configuracion de stock exportados",
                    { timer: 10, showCloseIcn: true }
                );
            });
        },
    }
}
</script>

<style scoped>
.stock-config-card {
    background: #ffffff;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    padding: 24px;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.stock-header-row {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 16px;
    margin-bottom: 1.25rem;
}

.stock-actions-row {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 0.5rem;
    flex-wrap: wrap;
    flex: 0 1 auto;
    max-width: 100%;
}

.stock-actions-row .btn {
    height: 44.8px;
    white-space: nowrap;
    display: flex;
    align-items: center;
    justify-content: center;
}

.stock-table-info-row {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 0.5rem;
    margin-top: 0.25rem;
}

.stock-total-count {
    font-size: 0.85rem;
    font-weight: 600;
    color: #6b7280;
    white-space: nowrap;
}

.stock-action-search {
    flex: 1 1 250px;
    min-width: 0;
}

.stock-action-search :deep(.search-container-wrapper),
.stock-action-search ::v-deep .search-container-wrapper,
.stock-action-search /deep/ .search-container-wrapper {
    width: 100%;
    max-width: none;
}

.stock-action-search ::v-deep .search-wrapper,
.stock-action-search /deep/ .search-wrapper {
    width: 100%;
}

@media (max-width: 767.98px) {
    .stock-actions-row {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 0.5rem;
        width: 100%;
        align-items: stretch;
    }

    .stock-actions-row > * {
        box-sizing: border-box;
        min-width: 0;
        width: 100%;
    }

    .stock-actions-row .btn {
        width: 100%;
        display: inline-flex;
        align-items: center;
        justify-content: center;
    }
}

@media (max-width: 575.98px) {
    .stock-actions-row {
        grid-template-columns: repeat(2, 1fr);
        gap: 0.4rem;
    }
}

/* Tabla */
.stock-table {
    border-collapse: collapse;
    font-size: 0.85rem;
}

.stock-table thead th {
    text-align: left;
    font-size: 0.7rem;
    font-weight: 700;
    color: #9ca3af;
    letter-spacing: 0.03em;
    padding: 10px 12px;
    border-bottom: 1px solid #e5e7eb;
    white-space: nowrap;
    background-color: #F3F4F6;
}

.stock-table tbody td {
    padding: 12px;
    border-bottom: 1px solid #f3f4f6;
    vertical-align: middle;
    color: #1f2937;
}

.stock-table tbody tr:hover {
    background: #fafafa;
}

.stock-sku-badge {
    display: inline-block;
    background: #f3f4f6;
    color: #374151;
    font-size: 0.78rem;
    font-weight: 600;
    padding: 3px 8px;
    border-radius: 6px;
}

.price-action-badge {
    display: inline-flex;
    align-items: center;
    padding: 4px 10px;
    border-radius: 999px;
    font-size: 0.78rem;
    font-weight: 700;
    line-height: 1;
    white-space: nowrap;
    background: #eef4ff;
    color: #2563eb;
    border: 1px solid #bfdbfe;
}

.inventory-alarm-badge {
    display: inline-flex;
    align-items: center;
    padding: 4px 10px;
    border-radius: 999px;
    font-size: 0.78rem;
    font-weight: 700;
    line-height: 1;
    white-space: nowrap;
    border: 1px solid transparent;
}

.inventory-alarm-badge--normal {
    background: #eefbf4;
    color: #1f7a4f;
    border-color: #bce8cd;
}

.inventory-alarm-badge--quiebre {
    background: #fff1f2;
    color: #b42318;
    border-color: #fecdd3;
}

.inventory-alarm-badge--stock {
    background: #fff8e6;
    color: #b45309;
    border-color: #fde68a;
}

.inventory-alarm-badge--neutral {
    background: #f3f4f6;
    color: #4b5563;
    border-color: #e5e7eb;
}

.button-export {
    background-color: #021418;
}

.button-products {
    padding: 10.5px 20px !important;
}

.stock-table thead th.editable-header {
    background-color: #E8F8F4;
    color: #087F6A;
    font-weight: 700;
}

.stock-table tbody td.col-highlight {
    background-color: #F8FCFB;
}

.icons-dark {
    filter: brightness(0);
    width: 18px;
    height: 18px;
}

.icons {
    filter: brightness(0) invert(1);
    width: 20px;
    height: 20px;
}
</style>
